/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.utils.form

import io.kvision.form.FormControl
import pl.finn.forms.model.DocumentTreeNode

data class FormElement(
  var fieldValue: DocumentTreeNode,
  var field: FormControl,
  var legend: String? = null,
  var required: Boolean = false,
  var requiredMessage: String? = null,
  var validatorMessage: ((FormControl) -> String?)? = null,
  var validator: ((FormControl) -> Boolean?)? = null
)
